import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { AppService } from '@Core/services/proprietary/app.service';
import { DataService } from '@Core/services/proprietary/data.service';

@Component({
    standalone: false,
    selector: 'condition-search-dialog',
    templateUrl: './condition-search-dialog.component.html',
    providers: [DataService] //force as a local provider
})
export class ConditionSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    //Override Method: called to construct initialize the search component
    initialize(): boolean {
        this.parentActiveModal = this.activeModal;
        this.objectType = 'Condition';
        this.model.title = 'Select Conditions';

        this.model.criteria.Condition_Name_Mode = 'Beginswith';

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }
}
